'use strict';

exports.__esModule = true;
exports.widgetActions = exports.LOGIN_REMEMBER_ME_CHECKED = exports.LOGIN_VALIDATION_FAILED = exports.LOGIN_SET_VALID_EMAIL = exports.LOGIN_EMAIL_CHANGE = exports.SET_UP_URL_PARAMETERS = exports.VALIDATION_FAILED = exports.LOGIN = undefined;

var _doctifyUtils = require('doctify-utils');

var LOGIN = exports.LOGIN = 'LOGIN_WIDGET:LOGIN'; // This is an example of the actions for a component that the page will compose.
// It should export string constants for its action types (with a prefix e.g. SEARCH_BAR:GET_LOCATIONS)
// and use those in the action methods (e.g. getLocationAutocomplete).

// Things with API calls will use createAction as commented out below. See doctify/home-page.

var VALIDATION_FAILED = exports.VALIDATION_FAILED = 'LOGIN_WIDGET:VALIDATION_FAILED';
var SET_UP_URL_PARAMETERS = exports.SET_UP_URL_PARAMETERS = 'LOGIN:SET_UP_URL_PARAMETERS';
var LOGIN_EMAIL_CHANGE = exports.LOGIN_EMAIL_CHANGE = 'LOGIN_WIDGET:LOGIN_EMAIL_CHANGE';
var LOGIN_SET_VALID_EMAIL = exports.LOGIN_SET_VALID_EMAIL = 'LOGIN_WIDGET:LOGIN_SET_VALID_EMAIL';
var LOGIN_VALIDATION_FAILED = exports.LOGIN_VALIDATION_FAILED = 'LOGIN_WIDGET:LOGIN_VALIDATION_FAILED';
var LOGIN_REMEMBER_ME_CHECKED = exports.LOGIN_REMEMBER_ME_CHECKED = 'LOGIN_WIDGET:LOGIN_REMEMBER_ME_CHECKED';

var widgetActions = exports.widgetActions = {
	validationError: function validationError() {
		return {
			type: LOGIN_VALIDATION_FAILED
		};
	},
	updateEmail: function updateEmail(email) {
		return {
			type: LOGIN_EMAIL_CHANGE,
			email: email
		};
	},
	rememberMeChecked: function rememberMeChecked() {
		return {
			type: LOGIN_REMEMBER_ME_CHECKED
		};
	},
	setValidEmail: function setValidEmail(valid) {
		return {
			type: LOGIN_SET_VALID_EMAIL,
			valid: valid
		};
	},
	parseUrlParameters: function parseUrlParameters(queryParameters) {
		return {
			type: SET_UP_URL_PARAMETERS,
			queryParameters: queryParameters
		};
	},
	login: function login(data, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'external/oauth/code',
			method: 'POST',
			data: data,
			actionType: LOGIN,
			xhrConfig: xhrConfig
		});
	}
};